import React from 'react';
import { Box, TableContainer, Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react";

const UploadDataTable = ({ headerRow, dataRows }) => {
  return (
    <Box
      mt={4}
      overflowX={{ base: "auto", md: "initial" }}
      width={{ base: "100%", md: "100%" }}
      maxW={{ base: "350px", md: "740px" }}
      maxH={{ base: "600px", md: "740px" }}
      overflowY="auto"
    >
      <TableContainer
        maxW="100%"
        overflowY={{ base: "auto", md: "hidden" }}
      >
        <Table
          size={{ base: "sm", md: "md" }}
          variant="striped"
        >
          <Thead>
            <Tr>
              {headerRow.map((header, index) => (
                <Th key={index}>{header}</Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {dataRows.map((row, index) => (
              <Tr key={index}>
                {row.map((cell, cellIndex) => (
                  <Td key={cellIndex}>{cell}</Td>
                ))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default UploadDataTable;